import React, { Component,Fragment } from 'react';
import Breadcrumb from "../../common/breadcrumb"

import { AvField, AvForm } from 'availity-reactstrap-validation';
import queryString from "query-string";
import { getObject, updateObject,  } from "../../api";
import JSONInput from 'react-json-editor-ajrm';
import locale    from 'react-json-editor-ajrm/locale/en';
import Editor from "../../common/quillEditor";
import { FlowDataEntry } from '../../common/flowDataEntry'

export class Menu_edit extends Component {
    constructor(props) {
        super(props)
        const value=queryString.parse(this.props.location.search);

        this.state = {
            loading: true,
            menuJson: "",
            pid: value.pid,
            data: {}
        }

        
    }

    imageUrlUpdated = (event) => {       
        this.setState( {data: {...this.state.data, imageUrl: event.target.value}});
    }

    onValidSubmit = (event, values) => {
        const formData = new FormData(document.getElementById('mainForm'));
        if (this.state.data.content) formData.append('content', this.state.data.content);
        formData.append('menuJson', this.state.menuJson);

        this.onSaveMenu(formData);
    };
    
    onInvalidSubmit = (event, errors, values) => {
        this.setState({errors, values});
    };

    onMenuJsonChanged = (event) => {
        this.state.menuJson = event.json;
    }

    handleContentChange = (value) => {
        this.setState({
            data: { ...this.state.data, content: value }
        });
    }

    onSaveMenu = (values) => {
        updateObject('menu', values, this.state.pid).then(d2 => {
            if (d2 && d2.error) {
                console.log(d2.error);
            } else {
                this.setState({pid: d2._id});
                this.loadMenu();
            }
        });
    };

    loadMenu = () => {
        this.setState({ loading: true});
        if (this.state.pid) {
            getObject('menu', this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {                     
                    this.setState({ 
                        data: d2, 
                        menuJson: d2.menuJson, 
                        loading: false});                    
                }
            });
        } else this.setState({ loading: false});
    };

    componentDidMount() {
        this.loadMenu();        
    }

    render() {
        const defaultValues = this.state.data;

        if (this.state.loading) { return null; }
        else {
            setTimeout(function() {
                document.querySelector(".loader-wrapper").style = "display: none";
            }, 100);       
        return (
            <Fragment>
                <Breadcrumb title={this.state.pid?"Edit Menu":"Add Menu"} parents={[{name: "Menus", url: "/admin/menu/list"}]} />
                <AvForm id="mainForm" className="needs-validation" onValidSubmit={this.onValidSubmit} onInvalidSubmit={this.onInvalidSubmit} model={defaultValues}>
                    <FlowDataEntry >
                        <Fragment>
                            <AvField label="Title" grid={{xs: 10}} name="title" id="title" type="text" />
                        </Fragment>
                        
                        <Fragment>                    
                            <AvField label="Image Url" grid={{xs: 10}} name="imageUrl" id="imageUrl" type="text" onBlur={(e) => this.imageUrlUpdated(e)}/>
                            <div className="row">
                                <div className="col-sm-2">
                                </div>
                                <div className="col-sm-10">  
                                    <img src={defaultValues.imageUrl}  style={{border:"1px solid #021a40", height:200}} alt=""/>
                                </div>
                            </div>
                        </Fragment>

                        <Editor 
                            content={defaultValues.content}
                            onContentChange={this.handleContentChange}
                        />

                        <Fragment>                    
                            <div className="row">
                                <div className="col-sm-2"> JSON
                                </div>
                                <div className="col-sm-10">  
                                    <JSONInput
                                    id          = 'a_unique_id'
                                    locale      = { locale }
                                    height      = '550px'
                                    width       = '100%'
                                    placeholder = { this.state.menuJson? JSON.parse(this.state.menuJson) : [  { name: 'Home', link: '/' } ] }
                                    onChange = {this.onMenuJsonChanged}
                                    />
                                </div>
                            </div>
                        </Fragment>                                                                                                                                

                    </FlowDataEntry>  
                </AvForm>  
            </Fragment>
        )
    }
}
}

export default Menu_edit
